module.exports = __webpack_public_path__ + "img/logo.bb18bfa7.svg";